import { forwardRef, type ComponentProps } from 'react';
import { TextField } from '@frontend/design-system';

export const PIN_MIN_LENGTH = 4;
export const PIN_MAX_LENGTH = 6;

type PinFieldProps = Omit<ComponentProps<typeof TextField>, 'type'> & {
  length?: number;
};

export const PinField = forwardRef<HTMLDivElement, PinFieldProps>(({ maxLength = PIN_MAX_LENGTH, ...props }, ref) => {
  const { transformValue, ...rest } = props as PinFieldProps & { transformValue?: unknown };
  return (
    <TextField
      {...rest}
      ref={ref}
      type='password'
      pattern='[0-9]*'
      autoComplete='one-time-code'
      maxLength={maxLength}
    />
  );
});

PinField.displayName = 'PinField';
